// Generated by deployment script - do not edit manually
const CONFIG = {
  region: "eu-west-1",
  userPoolId: "eu-west-1_FsgzM3eih",
  userPoolClientId: "2f0pn9km28uo6u2kkjqa13aa86",
  apiUrl: "https://rfqjnst3je.execute-api.eu-west-1.amazonaws.com/prod/",
  cognitoDomain: "usage-tracking-v2-975765645448",
  midwayEnabled: true,
};

export default CONFIG;
